<template>
    <el-container class="common-container">
        <el-header height="68px">
            <common-header />
        </el-header>
        <el-main>
            <router-view />
        </el-main>
        <el-footer>
            <common-footer />
        </el-footer>
    </el-container>
</template>

<script>
import { mapGetters } from 'vuex'
import commonHeader from './common-header'
import commonFooter from './common-footer'
export default {
    components: { commonHeader, commonFooter },
    computed: {
        ...mapGetters(['userInfo']),
    },
    data(){
        return {
            notify:null
        }
    },
    // watch:{   //检测邮箱有没有绑定,如果没绑定就给出提示
    //     'userInfo.emailActivation':{
    //         immediate: true,
    //         handler: function (val) {
    //             if(val == 0) {
    //                 const h = this.$createElement
    //                 this.notify =this.$notify({
    //                     title: '系统提示',
    //                     type: 'warning',
    //                     duration:0,
    //                     offset: 50,
    //                     message: h('div', { class: 'message' }, [
    //                         h('div', null, '检测到您还没有激活邮箱,后续将无法通过邮箱找回密码!'),[
    //                             h('span',null,'点击前往'),
    //                             h('span', {
    //                                 class: 'later',
    //                                 on: {
    //                                     click: this.doSomeThing
    //                                 }
    //                             },'激活邮箱!')
    //                         ]
    //                     ]),
    //                 });
    //             }else if(val == 1){
    //                 if(this.notify) this.notify.close()
    //             }
    //         }
    //     },
    // },
    // methods:{
    //     doSomeThing(){
    //         this.$router.push('/users/profile?type=activeEmail')
    //     }
    // }
}
</script>

<style lang="less" scoped>
.common-container {
    min-height: calc(100% + 60px);
    > .el-header {
        background-color: var(--main-bg-color);
        box-shadow: 0 0 6px 3px rgba(51, 51, 51, 0.10196078431372549);
    }
    > .el-main {
        padding: 0;
    }
    > .el-footer {
        color: hsla(0, 0%, 100%, 0.5);
        background-color: #333;
    }
}
.later{
    cursor: pointer;
    color: #14b14e;
    margin-left: 5px;
}
.later:hover{
    text-decoration: underline;
}
</style>
